function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "ic-community_svg__a"
}, React.createElement("path", {
  d: "M65 28.05c8.65 0 15.61 5.62 15.61 12.5S73.65 53.12 65 53.12a19.65 19.65 0 01-5.84-.89l-5.7 3.33.89-5.77a11.6 11.6 0 01-5-9.17c.04-6.95 7-12.57 15.65-12.57z",
  fill: "none"
})), React.createElement("clipPath", {
  id: "ic-community_svg__b"
}, React.createElement("path", {
  d: "M77.87 72.87h7.69a8.24 8.24 0 018.21 8.21v5.18H77.06v-1.48a8.3 8.3 0 00-6.22-8 8.4 8.4 0 017.03-3.91z",
  fill: "none"
})), React.createElement("clipPath", {
  id: "ic-community_svg__c"
}, React.createElement("path", {
  d: "M44.44 72.87h7.69a8.26 8.26 0 017 4 8.31 8.31 0 00-6.22 8v1.48H36.23v-5.2a8.16 8.16 0 018.21-8.28z",
  fill: "none"
})), React.createElement("clipPath", {
  id: "ic-community_svg__d"
}, React.createElement("circle", {
  cx: 48.28,
  cy: 64.29,
  r: 5.99,
  fill: "none"
})), React.createElement("clipPath", {
  id: "ic-community_svg__e"
}, React.createElement("circle", {
  cx: 65,
  cy: 68.06,
  r: 5.99,
  fill: "none"
})), React.createElement("clipPath", {
  id: "ic-community_svg__f"
}, React.createElement("circle", {
  cx: 81.72,
  cy: 64.29,
  r: 5.99,
  fill: "none"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.15 76.57h7.7a8.23 8.23 0 018.21 8.21V90H52.94v-5.22a8.23 8.23 0 018.21-8.21z",
  fill: "#90dee0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.44 72.87h7.69a8.26 8.26 0 017 4 8.31 8.31 0 00-6.22 8v1.48H36.23v-5.2a8.16 8.16 0 018.21-8.28z",
  fill: "#b0d84e"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.87 72.87h7.69a8.24 8.24 0 018.21 8.21v5.18H77.06v-1.48a8.3 8.3 0 00-6.22-8 8.4 8.4 0 017.03-3.91z",
  fill: "#f66"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65 28.05c8.65 0 15.61 5.62 15.61 12.5S73.65 53.12 65 53.12a19.65 19.65 0 01-5.84-.89l-5.7 3.33.89-5.77a11.6 11.6 0 01-5-9.17c.04-6.95 7-12.57 15.65-12.57z",
  fill: "#e22727"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__a)"
}, React.createElement("path", {
  d: "M65.93 26.64c8.65 0 15.6 5.62 15.6 12.5s-7 12.57-15.6 12.57a19.76 19.76 0 01-5.85-.88l-2.74-1.16-.34-.19-1.71-1.09a11.61 11.61 0 01-5-9.18c.03-6.95 6.98-12.57 15.64-12.57z",
  fill: "#f66"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 57.83,
  cy: 40.4,
  r: 1.11,
  fill: "#fff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65.07,
  cy: 40.4,
  r: 1.11,
  fill: "#fff"
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 72.25,
  cy: 40.4,
  r: 1.11,
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__b)"
}, React.createElement("path", {
  d: "M62.34 75.83H70A8.23 8.23 0 0178.24 84v5.17H54.13V84a8.23 8.23 0 018.21-8.17z",
  fill: "#fc3838"
}));

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__c)"
}, React.createElement("path", {
  d: "M59.82 75.78h7.7A8.24 8.24 0 0175.73 84v5.18H51.61V84a8.24 8.24 0 018.21-8.22z",
  fill: "#92b524"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 48.28,
  cy: 64.29,
  r: 5.99,
  fill: "#92b524"
});

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__d)"
}, React.createElement("circle", {
  cx: 49.3,
  cy: 63.76,
  r: 5.99,
  fill: "#b0d84e"
}));

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 68.06,
  r: 5.99,
  fill: "#61b5b5"
});

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__e)"
}, React.createElement("circle", {
  cx: 66.02,
  cy: 67.53,
  r: 5.99,
  fill: "#90dee0"
}));

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 81.72,
  cy: 64.29,
  r: 5.99,
  fill: "#fc3838"
});

var _ref22 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-community_svg__f)"
}, React.createElement("circle", {
  cx: 82.73,
  cy: 63.76,
  r: 5.99,
  fill: "#f66"
}));

var SvgIcCommunity = function SvgIcCommunity(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcCommunity as ReactComponent };